import React, { useState, useEffect, useCallback } from "react";
import {
  Switch,
  Button,
  Grid,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getAllPermisos } from "../services/permisos.service";
import {
  obtenerAccesosPorUsuario,
  guardarAccesosPorUsuario,
} from "../services/access.service";
import Loader from "./Loader";

const PermisosList = ({ usuario, setReload, reload, setIsVisibleModal }) => {
  const [accessStates, setAccessStates] = useState({});
  const [permisos, setPermisos] = useState([]);
  const [accesosUsuario, setAccesosUsuario] = useState([]);
  const [permisosAgrupados, setPermisosAgrupados] = useState([]);
  const [loading, setLoading] = useState(true); // Estado de carga

  const onCancel = () => {
    setIsVisibleModal(false); //
    setReload(!reload);
    setPermisosAgrupados([]);
  };

  const getAccesosUsuario = async () => {
    try {
      const accesosList = await obtenerAccesosPorUsuario(usuario.id_usuario);
      const initialAccessStates = permisos.reduce((acc, permiso) => {
        const acceso = accesosList.data.data.some(
          (accesoUsuario) => accesoUsuario.acceso === permiso.codigo
        );
        acc[permiso.id] = acceso;
        return acc;
      }, {});
      setAccessStates(initialAccessStates);
    } catch (error) {
      console.log("Failed to get access data", error);
    }
  };

  const getListaPermisos = async () => {
    setLoading(true); // Inicia la carga
    try {
      const permisosList = await getAllPermisos();
      if (permisosList.data.length > 0) {
        setPermisos(permisosList.data);

        // Espera a que se carguen los permisos antes de cargar accesos
        const accesosList = await obtenerAccesosPorUsuario(usuario.id_usuario);
        const initialAccessStates = permisosList.data.reduce((acc, permiso) => {
          const acceso = accesosList.data.data.some(
            (accesoUsuario) => accesoUsuario.acceso === permiso.codigo
          );
          acc[permiso.id] = acceso;
          return acc;
        }, {});
        setAccessStates(initialAccessStates);
      } else {
        setPermisos([]);
        setAccessStates({}); // Si no hay permisos, asegúrate de limpiar los accesos
      }
    } catch (error) {
      console.log("Failed to get permissions or access data", error);
    } finally {
      setLoading(false); // Finaliza la carga
    }
  };

  useEffect(() => {
    getListaPermisos();
    setPermisosAgrupados([]);
  }, [usuario]);

  const handleSwitchChange = (id) => {
    setAccessStates((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleSave = () => {
    const selectedAccessIds = Object.keys(accessStates)
      .filter((id) => accessStates[id])
      .map((id) => parseInt(id, 10));

    guardarAccesosPorUsuario(usuario.id_usuario, selectedAccessIds)
      .then(() => {
        setIsVisibleModal(false);
        setReload(!reload);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    // Agrupar permisos por grupo
    const grouped = permisos.reduce((acc, permiso) => {
      if (!acc[permiso.grupo]) {
        acc[permiso.grupo] = [];
      }
      acc[permiso.grupo].push(permiso);
      return acc;
    }, {});
    setPermisosAgrupados(grouped);
  }, [permisos, accessStates, usuario]);

  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      {Object.keys(permisosAgrupados).length > 0 ? (
        Object.keys(permisosAgrupados).map((grupo) => (
          <Accordion key={grupo}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">{grupo}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                {permisosAgrupados[grupo].map((permiso) => (
                  <Grid
                    item
                    xs={6}
                    key={permiso.id}
                    container
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography>{permiso.descripcion}</Typography>
                    <Switch
                      checked={accessStates[permiso.id] || false}
                      onChange={() => handleSwitchChange(permiso.id)}
                    />
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))
      ) : (
        <Typography>No hay permisos disponibles.</Typography>
      )}
      <div style={{ marginTop: 20 }}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Guardar
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={onCancel}
          style={{ marginLeft: 10 }}
        >
          Cancelar
        </Button>
      </div>
    </div>
  );
};

export default PermisosList;
